<template>
	<div class="tabulation">
		<el-card class="chart-card">
			<div style="margin-top: 20px;">
				<el-form ref="ruleFormRef" :model="form" :rules="rules" class="demo-ruleForm" :size="formSize"
					status-icon>
					<!-- 实事名称 -->
					<el-form-item label="实事名称" prop="title">
						<div class="aaaa">
							<el-input v-model="form.title" placeholder="请填写实事名称" size="large"></el-input>
						</div>
					</el-form-item>
					<!-- 操作模式 -->
					<el-form-item label="操作模式" prop="operationMode">
						<el-select v-model="form.operationMode" placeholder="请选择操作模式" size="medium">
							<el-option label="单次服务到店核销或纯展示" value="1"
								style="width:100%; text-align-last: center;"></el-option>
							<el-option label="多次在线支付购买" value="2"
								style="width:100%; text-align-last: center;"></el-option>
							<el-option label="手动多次发券到店核销" value="3"
								style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>
					<!-- 优惠名称 -->
					<el-form-item label="优惠名称" prop="preferentialTitle"
						v-if="form.operationMode== '单次服务到店核销或纯展示'|| form.operationMode==1">
						<div class="aaaa">
							<el-input v-model="form.preferentialTitle" placeholder="请填写优惠名称" size="large"></el-input>
						</div>
					</el-form-item>
					<!-- 是否发放优惠 -->
					<el-form-item label="是否发放优惠" prop="isPreferential"
						v-if="form.operationMode== '单次服务到店核销或纯展示'|| form.operationMode==1">
						<el-select v-model="form.isPreferential" placeholder="请选择是否发放优惠" size="medium">
							<el-option label="发放" value="1" style="width:100%; text-align-last: center;"></el-option>
							<el-option label="不发放" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>
					<!-- 卡片样式图片 -->
					<div class="" v-if="form.operationMode== '单次服务到店核销或纯展示'|| form.operationMode==1">
						<el-form-item label="卡片样式图片" prop="breviary1"
							v-if="form.isPreferential== '发放'|| form.isPreferential==1">
							<el-upload action="/admin/api/v1/doingPracticalThings/saveImage" list-type="picture-card"
								limit="1" v-model="form.breviary1" :auto-upload="true" :on-change="change1"
								:on-error="bedefeated" :on-success="handleUpImage1" :on-remove="Remove1"
								:class="styA1==0&&styD1==0?'styB':'styC'" :before-upload="beforeImageUpload1"
								:before-remove="beforeremove1" :on-preview="onpreview1" :file-list="approve1"
								accept=".jpeg,.png,.jpg,.bmp,.gif" :headers="header1" name="imageFile">
								<el-icon>
									<Plus />
								</el-icon>
							</el-upload>

							<el-dialog v-model="dialogVisible">
								<img w-full :src="dialogImageUrl" alt="Preview Image" style="width:100%" />
							</el-dialog>
							<div class="referrals">
								( 推荐：图片尺寸 宽700px、高420px。)
							</div>
						</el-form-item>
					</div>

					<!-- 金额 -->
					<el-form-item label="金额" prop="cash" v-if="form.operationMode== '多次在线支付购买'|| form.operationMode==2">
						<div class="aaaa">
							<el-input v-model="form.cash" placeholder="请填写金额" size="large"
								onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
						</div>
					</el-form-item>
					<!-- 是否收集手机号 -->
					<el-form-item label="是否收集手机号" prop="isMobile"
						v-if="form.operationMode== '多次在线支付购买'|| form.operationMode==2">
						<el-select v-model="form.isMobile" placeholder="请选择是否收集手机号" size="medium">
							<el-option label="是 " value="1" style="width:100%; text-align-last: center;"></el-option>
							<el-option label="否" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>
					<!-- 是否预约时间 -->
					<el-form-item label="是否预约时间" prop="isReservationTime"
						v-if="form.operationMode== '多次在线支付购买'|| form.operationMode==2">
						<el-select v-model="form.isReservationTime" placeholder="请选择是否预约时间" size="medium">
							<el-option label="是 " value="1" style="width:100%; text-align-last: center;"></el-option>
							<el-option label="否" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>
					<!-- 是否收集留言 -->
					<el-form-item label="是否收集留言" prop="isMessage"
						v-if="form.operationMode== '多次在线支付购买'|| form.operationMode==2">
						<el-select v-model="form.isMessage" placeholder="请选择是否收集留言" size="medium">
							<el-option label="是 " value="1" style="width:100%; text-align-last: center;"></el-option>
							<el-option label="否" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>
					<!-- 是否允许多次购买  -->
					<el-form-item label="是否允许多次购买 " prop="isManyBuy"
						v-if="form.operationMode== '多次在线支付购买'|| form.operationMode==2">
						<el-select v-model="form.isManyBuy" placeholder="请选择是否允许多次购买 " size="medium">
							<el-option label="是 " value="1" style="width:100%; text-align-last: center;"></el-option>
							<el-option label="否" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>
					<!-- 限制购买次数  -->
					<el-form-item label="限制购买次数 " prop="buyNumber"
						v-if="form.operationMode== '多次在线支付购买'|| form.operationMode==2">
						<div class="aaaa">
							<el-input v-model="form.buyNumber" placeholder="请填写限制购买次数" size="large"
								onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
						</div>
					</el-form-item>
					<!-- 是否为套餐模式  -->
					<el-form-item label="是否为套餐模式 " prop="isSetMenu"
						v-if="form.operationMode== '多次在线支付购买'|| form.operationMode==2">
						<el-select v-model="form.isSetMenu" placeholder="请选择是否为套餐模式 " size="medium">
							<el-option label="是 " value="1" style="width:100%; text-align-last: center;"></el-option>
							<el-option label="否" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>
					<!-- 是否收集销售姓名  -->
					<el-form-item label="是否收集销售姓名 " prop="isSalesName">
						<el-select v-model="form.isSalesName" placeholder="请选择是否收集销售姓名 " size="medium">
							<el-option label="是 " value="1" style="width:100%; text-align-last: center;"></el-option>
							<el-option label="否" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>
					<!-- 是否收集销售签名 -->
					<el-form-item label="是否收集销售签名" prop="isSign">
						<el-select v-model="form.isSign" placeholder="请选择是否收集销售签名" size="medium">
							<el-option label="是 " value="1" style="width:100%; text-align-last: center;"></el-option>
							<el-option label="否" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>
					<!-- 是否消息推送 -->
					<el-form-item label="是否消息推送" prop="isMessagePush">
						<el-select v-model="form.isMessagePush" placeholder="请选择是否消息推送" size="medium">
							<el-option label="推送 " value="1" style="width:100%; text-align-last: center;"></el-option>
							<el-option label="不推送" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>
					<!-- 手机号列表 -->
					<el-form-item label="手机号列表" prop="messageMobile"
						v-if="form.isMessagePush=='推送' || form.isMessagePush==1">
						<div class="aaaa">
							<el-input type="textarea" v-model="form.messageMobile" placeholder="请填写手机号列表"></el-input>
						</div>
						<div class="referrals">
							（提示：多个手机号用英文逗号隔开）
						</div>
					</el-form-item>
					<!-- 活动时间 -->
					<el-form-item label="活动时间" prop="value1">
						<div class="bilke">
							<el-date-picker size="large" v-model="form.value1" type="datetimerange" range-separator="截至"
								start-placeholder="开始时间" end-placeholder="结束时间" :default-time="defaultTime2" />
						</div>
					</el-form-item>
					<!-- 所属工会 -->
					<el-form-item label="所属工会" prop="choose">
						<div class="aaaa">
							<el-input v-model="form.choose" readonly placeholder="请选择所属工会"
								@click="visible = true"></el-input>
						</div>
					</el-form-item>
					<!-- 实事类型 -->
					<el-form-item label="实事类型" prop="type">
						<el-select v-model="form.type" placeholder="请选择实事类型" size="medium">
							<el-option label="直属机关工会" value="1"
								style="width:100%; text-align-last: center;"></el-option>
							<el-option label="基层工会" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>
					<!-- 是否发布 -->
					<el-form-item label="是否发布" prop="isEnable">
						<el-select v-model="form.isEnable" placeholder="请选择是否发布" size="medium">
							<el-option label="发布" value="1" style="width:100%; text-align-last: center;"></el-option>
							<el-option label="未发布" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>
					<!-- 排序 -->
					<el-form-item label="排序" prop="sort">
						<div class="aaaa">
							<el-input v-model="form.sort" type="number" placeholder="请填写排序值" size="large"></el-input>
						</div>
						<div class="referrals">
							（提示：大到小排序 默认100）
						</div>
					</el-form-item>
					<!-- 内页展示主图 -->
					<el-form-item label="内页展示主图" prop="isDisplayImage">
						<el-select v-model="form.isDisplayImage" placeholder="请选择内页是否展示主图" size="medium">
							<el-option label="展示 " value="1" style="width:100%; text-align-last: center;"></el-option>
							<el-option label="不展示" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>
					<!-- 标题图片 -->
					<el-form-item label="主题图片" prop="breviary">
						<el-upload action="/admin/api/v1/doingPracticalThings/saveImage" list-type="picture-card"
							limit="1" v-model="form.breviary" :auto-upload="true" :on-change="change"
							:on-error="bedefeated" :on-success="handleUpImage" :on-remove="Remove"
							:class="styA==0&&styD==0?'styB':'styC'" :before-upload="beforeImageUpload"
							:before-remove="beforeremove" :on-preview="onpreview" :file-list="approve"
							accept=".jpeg,.png,.jpg,.bmp,.gif" :headers="header" name="imageFile">
							<el-icon>
								<Plus />
							</el-icon>
						</el-upload>

						<el-dialog v-model="dialogVisible">
							<img w-full :src="dialogImageUrl" alt="Preview Image" style="width:100%" />
						</el-dialog>
						<div class="referrals">
							( 推荐：图片尺寸 宽700px、高400px。)
						</div>
					</el-form-item>

					<!-- 编辑器 -->
					<el-form-item prop="copyreader">
						<div class="subject">
							<span class="xingxing">*</span>
							主体内容
							<span class="referrals">( 推荐：视频体积小于100M，图片体积小于1M。 )</span>
						</div>
						<div style="border: 1px solid #ccc; width:100%">
							<Toolbar style="border-bottom: 1px solid #ccc" :editor="editorRef"
								:defaultConfig="toolbarConfig" :mode="mode" />

							<Editor style="height: 500px; overflow-y: hidden" v-model="valueHtml"
								:defaultConfig="editorConfig" :mode="mode" @onCreated="handleCreated" />
						</div>
					</el-form-item>
				</el-form>
			</div>
			<el-button type="primary" size="large" style="margin-top: 20px;" :loading="ConfirmLoading"
				@click="onSubmit">提交</el-button>
			<!-- 所属工会选择 -->
			<div>
				<el-dialog v-model="visible" title="所属工会" width="500px" top="10vh" custom-class="organization-dialog" :close-on-click-modal="true" destroy-on-close>
					<el-tree :data="texture" :props="defaultProps" accordion @node-click="dendrogram" />
					<template #footer><el-button type="primary" @click="visible = false">确定</el-button></template>
				</el-dialog>
			</div>
		</el-card>
	</div>
</template>
<script>
	import '@wangeditor/editor/dist/css/style.css' // 引入 css
	import {
		onBeforeUnmount,
		ref,
		shallowRef,
		onMounted,
		reactive,
		onActivated,
	} from 'vue'
	import {
		Editor,
		Toolbar
	} from '@wangeditor/editor-for-vue'
	import {
		Plus,
	} from '@element-plus/icons-vue'
	import * as imageConversion from 'image-conversion'
	import {
		ElMessage
	} from "element-plus";
	import {
		editThings,
		ZClist,
		infoThings,
	} from "../../utils/api"
	import {
		useRouter,
		useRoute
	} from "vue-router";
	// import { Pictures } from '../../utils/api'
	import {
		useStore
	} from "vuex";
	import qs from 'qs'
	import moments from 'moment'
	export default {
		name: "ssedit",
		components: {
			Editor,
			Toolbar,
			Plus,
		},
		setup() {
			//获取列表页传来的id
			const route = useRoute()
			let loading = ref(true)
			let spChildIndex = ref(0)
			// 默认显示主题上传文件
			let approve = ref([{}])
			// 默认显示卡片上传文件
			let approve1 = ref([{}])
			//流程详情获取
			let infoThingss = () => {
				let data = {
					id: sessionStorage.getItem('thingsIds')
				}
				// var userNames = ref([])
				const id = ref([])
				infoThings(qs.stringify(data)).then((res) => {
					if (res.data.code == 0) {
						// 活动名称
						form.title = res.data.data.doingPracticalThingsInfo.title
						// 优惠名称
						form.preferentialTitle = res.data.data.doingPracticalThingsInfo.preferentialTitle
						// 时间
						let staet = ref(moments(res.data.data.doingPracticalThingsInfo.startTime * 1000)
							.format('YYYY-MM-DD HH:mm:ss'))
						let enables = ref(moments(res.data.data.doingPracticalThingsInfo.endTime * 1000)
							.format('YYYY-MM-DD HH:mm:ss'))
						initiation.value = res.data.data.doingPracticalThingsInfo.startTime
						terminate.value = res.data.data.doingPracticalThingsInfo.endTime
						form.value1 = [staet.value, enables.value]
						// 选择工会
						gaincode.value = res.data.data.doingPracticalThingsInfo.unionCode
						messge()
						//是否发放
						if (res.data.data.doingPracticalThingsInfo.isPreferential == 1) {
							form.isPreferential = '发放'
							// approve1.value[0].url=res.data.data.doingPracticalThingsInfo.cardImageInfo
							// form.breviary1=res.data.data.doingPracticalThingsInfo.cardImageInfo
						} else if (res.data.data.doingPracticalThingsInfo.isPreferential == 2) {
							form.isPreferential = '不发放'
						}
						//操作模式
						if (res.data.data.doingPracticalThingsInfo.operationMode == 1) {
							form.operationMode = '单次服务到店核销或纯展示'
						} else if (res.data.data.doingPracticalThingsInfo.operationMode == 2) {
							form.operationMode = '多次在线支付购买'
						} else if (res.data.data.doingPracticalThingsInfo.operationMode == 3) {
							form.operationMode = '手动多次发券到店核销'
						}
						//金额
						form.cash = res.data.data.doingPracticalThingsInfo.cash
						//是否收集手机号 
						if (res.data.data.doingPracticalThingsInfo.isMobile == 1) {
							form.isMobile = '是'
						} else if (res.data.data.doingPracticalThingsInfo.isMobile == 2) {
							form.isMobile = '否'
						}
						//是否预约时间 
						if (res.data.data.doingPracticalThingsInfo.isReservationTime == 1) {
							form.isReservationTime = '是'
						} else if (res.data.data.doingPracticalThingsInfo.isReservationTime == 2) {
							form.isReservationTime = '否'
						}
						//是否预约时间
						if (res.data.data.doingPracticalThingsInfo.isReservationTime == 1) {
							form.isReservationTime = '是'
						} else if (res.data.data.doingPracticalThingsInfo.isReservationTime == 2) {
							form.isReservationTime = '否'
						}
						//是否收集留言
						if (res.data.data.doingPracticalThingsInfo.isMessage == 1) {
							form.isMessage = '是'
						} else if (res.data.data.doingPracticalThingsInfo.isMessage == 2) {
							form.isMessage = '否'
						}
						//是否允许多次购买
						if (res.data.data.doingPracticalThingsInfo.isManyBuy == 1) {
							form.isManyBuy = '是'
						} else if (res.data.data.doingPracticalThingsInfo.isManyBuy == 2) {
							form.isManyBuy = '否'
						}
						//限制购买次数
						form.buyNumber = res.data.data.doingPracticalThingsInfo.buyNumber
						//是否为套餐模式
						if (res.data.data.doingPracticalThingsInfo.isSetMenu == 1) {
							form.isSetMenu = '是'
						} else if (res.data.data.doingPracticalThingsInfo.isSetMenu == 2) {
							form.isSetMenu = '否'
						}
						//是否收集销售姓名
						if (res.data.data.doingPracticalThingsInfo.isSalesName == 1) {
							form.isSalesName = '是'
						} else if (res.data.data.doingPracticalThingsInfo.isSalesName == 2) {
							form.isSalesName = '否'
						}
						//是否收集销售签名 
						if (res.data.data.doingPracticalThingsInfo.isSign == 1) {
							form.isSign = '是'
						} else if (res.data.data.doingPracticalThingsInfo.isSign == 2) {
							form.isSign = '否'
						}
						//是否消息推送
						if (res.data.data.doingPracticalThingsInfo.isMessagePush == 1) {
							form.isMessagePush = '推送'
						} else if (res.data.data.doingPracticalThingsInfo.isMessagePush == 2) {
							form.isMessagePush = '不推送'
						}
						// 手机号列表
						form.messageMobile = res.data.data.doingPracticalThingsInfo.messageMobile
						//活动类型
						if (res.data.data.doingPracticalThingsInfo.type == 1) {
							form.type = '直属机关工会'
						} else if (res.data.data.doingPracticalThingsInfo.type == 2) {
							form.type = '基层工会'
						}
						//是否发布
						if (res.data.data.doingPracticalThingsInfo.isEnable == 1) {
							form.isEnable = '发布'
						} else if (res.data.data.doingPracticalThingsInfo.isEnable == 2) {
							form.isEnable = '未发布'
						}
						//内页展示主图
						if (res.data.data.doingPracticalThingsInfo.isDisplayImage == 1) {
							form.isDisplayImage = '展示'
						} else if (res.data.data.doingPracticalThingsInfo.isDisplayImage == 2) {
							form.isDisplayImage = '不展示'
						}
						//排序
						form.sort = res.data.data.doingPracticalThingsInfo.sort
						//卡片图片
						if (res.data.data.doingPracticalThingsInfo.cardImageInfo != "") {
							approve1.value[0].url = res.data.data.doingPracticalThingsInfo.cardImageInfo
							form.breviary1 = res.data.data.doingPracticalThingsInfo.cardImageInfo
						} else {
							styA1.value = 0
							styD1.value = 0
							approve1.value = ref([])
						}
						//主题图片
						approve.value[0].url = res.data.data.doingPracticalThingsInfo.imageInfo
						form.breviary = res.data.data.doingPracticalThingsInfo.imageInfo
						//编辑器内容
						valueHtml.value = res.data.data.doingPracticalThingsInfo.content

					}
				})
			}
			// const route = useRoute();
			// 清空图片
			const qingkong = ref('')
			let data = ref(null);
			// 按钮加载
			const ConfirmLoading = ref(false)

			// 上传主题图片
			const header = ref({
				timeout: 10000,
				'accessToken': sessionStorage.getItem('token')
			})
			// 上传卡片图片
			const header1 = ref({
				timeout: 10000,
				'accessToken': sessionStorage.getItem('token')
			})
			// 获取上传主题图片成功地址
			// let location = ref('')
			// const succ = (res) => {
			// 	location.value = res.data

			// }
			// 获取上传卡片图片成功地址
			// let location1 = ref('')
			// const succ1 = (res) => {
			// 	location1.value = res.data

			// }
			// 自定义上传
			// const httpreqst = (param) => {

			// 	data.value = {
			// 		imageFile: param.file.namefileList
			// 	}
			// 	// Pictures(data).then((res)=>{

			// 	// })
			// }
			const styA = ref(0)
			const styD = ref(1)
			const change = (res, fileList) => {
				styA.value = fileList.length
				form.breviary = fileList
			}
			const styA1 = ref(0)
			const styD1 = ref(1)
			const change1 = (res, fileList) => {
				styA1.value = fileList.length
				form.breviary1 = fileList
			}
			const beforeImageUpload = (File) => {
				let isLt2M = File.size / 1024 / 1024 < 1
				return new Promise((resolve) => {
					if (isLt2M) {
						resolve(File)
					}
					imageConversion.compressAccurately(File, 930).then((res) => {
						resolve(res);
						// data.value = File.name
					});
				})
			}
			const beforeImageUpload1 = (File) => {
				let isLt2M = File.size / 1024 / 1024 < 1
				return new Promise((resolve) => {
					if (isLt2M) {
						resolve(File)
					}
					imageConversion.compressAccurately(File, 930).then((res) => {
						resolve(res);
						// data.value = File.name
					});
				})
			}
			// 上传成功，获取返回的图片地址
			let location = ref('')
			const handleUpImage = (res) => {
				location.value = res.data
			}
			// 上传成功，获取返回的图片地址
			let location1 = ref('')
			const handleUpImage1 = (res) => {
				location1.value = res.data
			}
			// 图片放大
			const dialogVisible = ref(false)
			let dialogImageUrl = ref('')
			const onpreview = (File) => {
				dialogVisible.value = true
				dialogImageUrl.value = File.url
			}
			const onpreview1 = (File) => {
				dialogVisible.value = true
				dialogImageUrl.value = File.url
			}
			// 删除主题图片
			const beforeremove = (File, fileList) => {
				styA.value = 0
				styD.value = 0
				form.breviary = ''
			}
			const Remove = (file) => {
			
			}
			// 删除卡片图片
			const beforeremove1 = (File, fileList1) => {
				styA1.value = 0
				styD1.value = 0
				form.breviary1 = ''
			}
			const Remove1 = (file) => {
				
			}
			// 获取工会列表信息
			const messge = () => {
				ZClist().then((res) => {
					texture.value = res.data.data.manageUnionList
					const arr3 = texture.value.filter(function(num) {
						return num.unionCode == gaincode.value
					})
					if (arr3.length == 0) {
						texture.value.forEach((item) => {
							const arr4 = item.unionDtoList.filter(function(num) {
								return num.unionCode == gaincode.value
							})
							if (arr4.length == 0) {
								item.unionDtoList.forEach((items) => {
									const arr5 = items.unionDtoList.filter(function(nums) {
										return nums.unionCode == gaincode.value
									})
									if (arr5.length == 0) {
										items.unionDtoList.forEach((ite) => {
											const arr6 = ite.unionDtoList.filter(
												function(numss) {
													return numss.unionCode ==
														gaincode.value
												})
											if (arr6.length == 0) {
												ite.unionDtoList.forEach((it) => {
													const arr7 = it
														.unionDtoList.filter(
															function(numsss) {
																return numsss
																	.unionCode ==
																	gaincode
																	.value
															})
													if (arr7.length == 0) {
														it.unionDtoList
															.forEach((i) => {
																const
																	arr8 =
																	i
																	.unionDtoList
																	.filter(
																		function(
																			numssss
																		) {
																			return numssss
																				.unionCode ==
																				gaincode
																				.value
																		})
																if (arr8
																	.length ==
																	0) {
																	i.unionDtoList
																		.forEach(
																			(
																				s
																			) => {
																				const
																					arr9 =
																					s
																					.unionDtoList
																					.filter(
																						function(
																							nu
																						) {
																							return nu
																								.unionCode ==
																								gaincode
																								.value
																						}
																					)
																				if (arr9
																					.length ==
																					0
																				) {
																					s.unionDtoList
																						.forEach(
																							(
																								a
																							) => {
																								const
																									arr10 =
																									a
																									.unionDtoList
																									.filter(
																										function(
																											cat
																										) {
																											return cat
																												.unionCode ==
																												gaincode
																												.value
																										}
																									)
																								if (arr10
																									.length ==
																									0
																								) {
																									a.unionDtoList
																										.forEach(
																											(
																												d
																											) => {
																												const
																													arr11 =
																													d
																													.unionDtoList
																													.filter(
																														function(
																															dog
																														) {
																															return dog
																																.unionCode ==
																																gaincode
																																.value
																														}
																													)
																												if (arr11
																													.length ==
																													0
																												) {
																													d.unionDtoList
																														.forEach(
																															(
																																f
																															) => {
																																const
																																	arr12 =
																																	f
																																	.unionDtoList
																																	.filter(
																																		function(
																																			long
																																		) {
																																			return long
																																				.unionCode ==
																																				gaincode
																																				.value
																																		}
																																	)
																																arr12
																																	.forEach(
																																		(
																																			item
																																		) => {
																																			form.choose =
																																				arr3
																																				.unionName =
																																				item
																																				.unionName
																																			gaincode
																																				.value =
																																				arr3
																																				.unionCode =
																																				item
																																				.unionCode
																																		}
																																	)
																															}
																														)
																												}
																												arr11
																													.forEach(
																														(
																															item
																														) => {
																															form.choose =
																																arr3
																																.unionName =
																																item
																																.unionName
																															gaincode
																																.value =
																																arr3
																																.unionCode =
																																item
																																.unionCode
																														}
																													)
																											}
																										)
																								}
																								arr10
																									.forEach(
																										(
																											item
																										) => {
																											form.choose =
																												arr3
																												.unionName =
																												item
																												.unionName
																											gaincode
																												.value =
																												arr3
																												.unionCode =
																												item
																												.unionCode
																										}
																									)
																							}
																						)
																				}
																				arr9.forEach(
																					(
																						item
																					) => {
																						form.choose =
																							arr3
																							.unionName =
																							item
																							.unionName
																						gaincode
																							.value =
																							arr3
																							.unionCode =
																							item
																							.unionCode
																					}
																				)
																			}
																		)
																}
																arr8.forEach(
																	(
																		item
																	) => {
																		form.choose =
																			arr3
																			.unionName =
																			item
																			.unionName
																		gaincode
																			.value =
																			arr3
																			.unionCode =
																			item
																			.unionCode
																	})
															})
													}
													arr7.forEach((item) => {
														form.choose =
															arr3
															.unionName =
															item
															.unionName
														gaincode
															.value =
															arr3
															.unionCode =
															item
															.unionCode
													})
												})
											}
											arr6.forEach((item) => {
												form.choose = arr3.unionName =
													item.unionName
												gaincode.value = arr3
													.unionCode = item.unionCode
											})
										})
									}
									arr5.forEach((item) => {
										form.choose = arr3.unionName = item.unionName
										gaincode.value = arr3.unionCode = item
											.unionCode
									})
								})
							} else {
								arr4.forEach((item) => {
									form.choose = arr3.unionName = item.unionName
									gaincode.value = arr3.unionCode = item.unionCode
								})
							}
						})
					} else {
						arr3.forEach((item) => {
							form.choose = arr3.unionName = item.unionName
							gaincode.value = arr3.unionCode = item.unionCode
						})
					}
				})
			}
			// 所属工会选择
			const yes = () => {
				form.choose = options.value
				visible.value = false;
			};
			// 获取工会code
			let gaincode = ref('')
			// 树形选择
			let options = ref('')
			let dendrogram = (node) => {
				options.value = node.unionName
				form.choose = options.value
				gaincode.value = node.unionCode
			}
			const defaultProps = {
				children: 'unionDtoList',
				label: 'unionName',
			}
			let texture = ref([])
			// 开始时间
			let initiation = ref('')
			// 结束时间
			let terminate = ref('')
			const defaultTime2 = [
				new Date(2000, 1, 1, 0, 0, 0),
				new Date(2000, 2, 1, 23, 59, 59),

			]
			let translate = ref(2)
			onActivated(() => {
				translate.value = route.params.UserId
				if (translate.value == 1) {
					loading.value = true
					infoThingss()
				}
			})
			// 添加按钮是否显示
			// let styD = ref(0)
			// 关闭当前页
			const store = useStore();
			const current = ref('')
			const expression = ref([])
			const Indexs = ref(null)
			// 提交 按钮
			const router = useRouter();
			const onSubmit = () => {
				if (valueHtml.value == '<p><br></p>') {
					form.copyreader = ''
				} else {
					form.copyreader = valueHtml.value
				}
				var b = ref(new Date(form.value1[0]))
				var begin = ref('')
				begin.value = b.value.getFullYear() + '-' + (b.value.getMonth() + 1) + '-' + b.value.getDate() + ' ' +
					b.value.getHours() + ':' + b.value.getMinutes() + ':' + b.value.getSeconds();
				var start = ref(new Date(begin.value).getTime() / 1000)
				// 截至时间
				var d = ref(new Date(form.value1[1]))
				var finish = ref('')
				finish.value = d.value.getFullYear() + '-' + (d.value.getMonth() + 1) + '-' + d.value.getDate() + ' ' +
					d.value.getHours() + ':' + d.value.getMinutes() + ':' + d.value.getSeconds();
				var over = ref(new Date(finish.value).getTime() / 1000)
				//是否发放优惠转换
				let isPreferentials = ref(null)
				if (form.isPreferential == '发放') {
					isPreferentials.value = 1
				} else if (form.isPreferential == '不发放') {
					isPreferentials.value = 2
				} else if (form.isPreferential == 1) {
					isPreferentials.value = 1
				} else if (form.isPreferential == 2) {
					isPreferentials.value = 2
				}
				//实事类型转换
				let types = ref(null)
				if (form.type == '直属机关工会') {
					types.value = 1
				} else if (form.type == '基层工会') {
					types.value = 2
				} else if (form.type == 1) {
					types.value = 1
				} else if (form.type == 2) {
					types.value = 2
				}
				//是否发布转换
				let isEnables = ref(null)
				if (form.isEnable == '发布') {
					isEnables.value = 1
				} else if (form.isEnable == '未发布') {
					isEnables.value = 2
				} else if (form.isEnable == 1) {
					isEnables.value = 1
				} else if (form.isEnable == 2) {
					isEnables.value = 2
				}
				//是否消息推送
				let isMessagePushs = ref(null)
				if (form.isMessagePush == '推送') {
					isMessagePushs.value = 1
				} else if (form.isMessagePush == '不推送') {
					isMessagePushs.value = 2
				} else if (form.isMessagePush == 1) {
					isMessagePushs.value = 1
				} else if (form.isMessagePush == 2) {
					isMessagePushs.value = 2
				}
				//是否收集销售姓名 
				let isSalesNames = ref(null)
				if (form.isSalesName == '是') {
					isSalesNames.value = 1
				} else if (form.isSalesName == '否') {
					isSalesNames.value = 2
				} else if (form.isSalesName == 1) {
					isSalesNames.value = 1
				} else if (form.isSalesName == 2) {
					isSalesNames.value = 2
				}
				//是否收集销售签名
				let isSigns = ref(null)
				if (form.isSign == '是') {
					isSigns.value = 1
				} else if (form.isSign == '否') {
					isSigns.value = 2
				} else if (form.isSign == 1) {
					isSigns.value = 1
				} else if (form.isSign == 2) {
					isSigns.value = 2
				}
				//操作模式
				let operationModes = ref(null)
				if (form.operationMode == '单次服务到店核销或纯展示') {
					operationModes.value = 1
				} else if (form.operationMode == '多次在线支付购买') {
					operationModes.value = 2
				} else if (form.operationMode == '手动多次发券到店核销') {
					operationModes.value = 3
				} else if (form.operationMode == 1) {
					operationModes.value = 1
				} else if (form.operationMode == 2) {
					operationModes.value = 2
				} else if (form.operationMode == 3) {
					operationModes.value = 3
				}
				//是否收集手机号 
				let isMobiles = ref(null)
				if (form.isMobile == '是') {
					isMobiles.value = 1
				} else if (form.isMobile == '否') {
					isMobiles.value = 2
				} else if (form.isMobile == 1) {
					isMobiles.value = 1
				} else if (form.isMobile == 2) {
					isMobiles.value = 2
				}
				//是否预约时间 
				let isReservationTimes = ref(null)
				if (form.isReservationTime == '是') {
					isReservationTimes.value = 1
				} else if (form.isReservationTime == '否') {
					isReservationTimes.value = 2
				} else if (form.isReservationTime == 1) {
					isReservationTimes.value = 1
				} else if (form.isReservationTime == 2) {
					isReservationTimes.value = 2
				}
				//是否收集留言
				let isMessages = ref(null)
				if (form.isMessage == '是') {
					isMessages.value = 1
				} else if (form.isMessage == '否') {
					isMessages.value = 2
				} else if (form.isMessage == 1) {
					isMessages.value = 1
				} else if (form.isMessage == 2) {
					isMessages.value = 2
				}
				//是否允许多次购买 
				let isManyBuys = ref(null)
				if (form.isManyBuy == '是') {
					isManyBuys.value = 1
				} else if (form.isManyBuy == '否') {
					isManyBuys.value = 2
				} else if (form.isManyBuy == 1) {
					isManyBuys.value = 1
				} else if (form.isManyBuy == 2) {
					isManyBuys.value = 2
				}
				//是否为套餐模式
				let isSetMenus = ref(null)
				if (form.isSetMenu == '是') {
					isSetMenus.value = 1
				} else if (form.isSetMenu == '否') {
					isSetMenus.value = 2
				} else if (form.isSetMenu == 1) {
					isSetMenus.value = 1
				} else if (form.isSetMenu == 2) {
					isSetMenus.value = 2
				}
				//内页展示主图
				let isDisplayImages = ref(null)
				if (form.isDisplayImage == '展示') {
					isDisplayImages.value = 1
				} else if (form.isDisplayImage == '不展示') {
					isDisplayImages.value = 2
				} else if (form.isDisplayImage == 1) {
					isDisplayImages.value = 1
				} else if (form.isDisplayImage == 2) {
					isDisplayImages.value = 2
				}
				ruleFormRef.value.validate((valid) => {
					let data = {
						id: sessionStorage.getItem('thingsIds'),
						// 活动名称
						title: form.title,
						//操作模式
						operationMode: operationModes.value,
						//金额
						cash: form.cash,
						//是否收集手机号 
						isMobile: isMobiles.value,
						//是否预约时间
						isReservationTime: isReservationTimes.value,
						//是否收集留言 
						isMessage: isMessages.value,
						//是否允许多次购买
						isManyBuy: isManyBuys.value,
						//限制购买次数
						buyNumber: form.buyNumber,
						//是否为套餐模式
						isSetMenu: isSetMenus.value,
						//优惠名称
						preferentialTitle: form.preferentialTitle,
						//是否发放优惠
						isPreferential: isPreferentials.value,
						//卡片图片
						cardImageInfo: location1.value,
						//是否收集销售姓名
						isSalesName: isSalesNames.value,
						//是否收集销售签名
						isSign: isSigns.value,
						//是否消息推送
						isMessagePush: isMessagePushs.value,
						//手机号列表
						messageMobile: form.messageMobile,
						//选择开始和截止时间
						startTime: start.value,
						endTime: over.value,
						//工会CODE
						unionCode: gaincode.value,
						// 活动类型
						type: types.value,
						//是否发布
						isEnable: isEnables.value,
						//内页展示主图
						isDisplayImage: isDisplayImages.value,
						//排序
						sort: form.sort,
						// 图片
						imageInfo: location.value,
						// 编辑器内容
						content: form.copyreader,

					}
					if (valid == true) {
						ConfirmLoading.value = true
						editThings(qs.parse(data)).then((res) => {
							if (res.data.code == 0) {
								ElMessage({
									message: '提交成功',
									type: "success",
									center: true,
								});
								setTimeout(() => {
									current.value = route.path
									expression.value = store.state.tagsList

									expression.value.forEach((item, index) => {
										if (current.value == item.path) {
											Indexs.value = index
										}
									})
									store.state.tagsList.splice(Indexs.value, 1)
									router.push({
										name: 'doingThings',
										params: {
											userId: 1
										}
									});
									ConfirmLoading.value = false
								}, 500)
							} else {
								ElMessage({
									message: res.data.msg,
									type: "error",
									center: true,
								});
								ConfirmLoading.value = false
							}
						})
					} else {
						ElMessage({
							message: "提交失败",
							type: "error",
							center: true,
						});
						ConfirmLoading.value = false
					}
				})
			}
			// 编辑器实例，必须用 shallowRef
			const editorRef = shallowRef()

			// 内容 HTML
			const valueHtml = ref('')

			// 模拟 ajax 异步获取内容
			onMounted(() => {
				messge()
				infoThingss()

			})

			const toolbarConfig = {
				toolbarKeys: [
					'bold', // 加粗
					'italic', // 斜体
					'through', // 删除线
					'underline', // 下划线
					'bulletedList', // 无序列表
					'numberedList', // 有序列表
					'color', // 文字颜色
					'fontSize', // 字体大小
					'lineHeight', // 行高
					'uploadImage', // 上传图片
					'delIndent', // 缩进
					'indent', // 增进
					'deleteImage', //删除图片
					'justifyCenter', // 居中对齐
					'justifyJustify', // 两端对齐
					'justifyLeft', // 左对齐
					'justifyRight', // 右对齐
					'undo', // 撤销
					'redo', // 重做
					'clearStyle', // 清除格式
					'uploadVideo',
				],
				excludeKeys: [
					'insertImage', // 网络图片
					'bgColor', // 背景色
					'blockquote', // 引用
					'codeBlock', // 代码段
					'emotion', // 表情
					'fontFamily', // 字体
					'headerSelect', // 标题 
					'fullScreen', // 全屏
				],
			}
			// 富文本上传图片地址
			// let fils=ref('')
			// placeholder: '请输入内容...',
			const editorConfig = {
				MENU_CONF: {}
			}
			// 视频上传
			editorConfig.MENU_CONF['uploadVideo'] = {
				// 上传视频的配置
				// 接口
				server: '/admin/api/v1/doingPracticalThings/saveEditorImage',
				// 请求头
				headers: {
					timeout: 10000,
					'accessToken': sessionStorage.getItem('token')
				},
				// 限制上传视频大小
				maxFileSize: 104857600, // 100M
				//上传字段 
				fieldName: 'imageFile',
				maxNumberOfFiles: 1,
				// 上传前回调
				onBeforeUpload(file) {
					let fileObj = Object.values(file)[0].data
					// 判断视频是否大于100M
					let isLt2M = Object.values(file)[0].data.size
					if (isLt2M < 104857600) {
						return true
					} else if (isLt2M > 104857600) {
						ElMessage({
							message: '视频大小不能超过100MB,请重新上传',
							type: "warning",
							center: true,
						});
						return false
					}
				},
				// 上传成功后回调
				onSuccess(file, res) {
					
				},
				// 上传失败回调
				onError(file, res) {
					if (file.size > 104857600) {
						ElMessage({
							message: '视频大小不能超过100MB,请重新上传',
							type: "warning",
							center: true,
						});
					} else {
						ElMessage({
							message: '上传失败，请稍后再试',
							type: "warning",
							center: true,
						});
					}
				},
			}


			// 图片上传
			editorConfig.MENU_CONF['uploadImage'] = {
				// 上传图片的配置 
				// 接口
				server: '/admin/api/v1/doingPracticalThings/saveEditorImage',
				// 请求头
				headers: {
					timeout: 10000,
					'accessToken': sessionStorage.getItem('token')
				},
				maxFileSize: 1 * 1024 * 1024, // 1M
				//上传字段 
				fieldName: 'imageFile',
				// meta: {
				//   imageFile:fils
				// },
				// 最多可上传几个文件，默认为 100
				maxNumberOfFiles: 1,
				// 上传前回调
				onBeforeUpload(file) {
					let fileObj = Object.values(file)[0].data
					// 压缩图片
					let isLt2M = Object.values(file)[0].data.size
					if (isLt2M < 1048576) {
						return true
					} else if (isLt2M > 1048576) {
						ElMessage({
							message: '图片大小不能超过1MB,请重新上传',
							type: "warning",
							center: true,
						});
						return false
					}
				},
				// 上传成功后回调
				onSuccess(file, res) {
					
				},
				// 上传失败回调
				onError() {
					ElMessage({
						message: '图片大小不能超过1MB,请重新上传',
						type: "warning",
						center: true,
					});
				},
			}

			// 组件销毁时，也及时销毁编辑器
			onBeforeUnmount(() => {
				const editor = editorRef.value
				if (editor == null) return
				editor.destroy()
			})

			const handleCreated = (editor) => {
				editorRef.value = editor // 记录 editor 实例，重要！
			}
			const visible = ref(false);
			// 标题验证
			const ruleFormRef = ref(null)
			const form = reactive({
				title: "",
				preferentialTitle: "",
				isPreferential: "",
				value1: "",
				choose: "",
				type: "",
				isEnable: "",
				isDisplayImage: '',
				sort: '',
				copyreader: "",
				breviary: "",
				breviary1: "",
				isMessagePush: "",
				messageMobile: "",
				operationMode: "",
				cash: "",
				isMobile: "",
				isReservationTime: "",
				isMessage: "",
				isManyBuy: "",
				isSetMenu: "",
				buyNumber: "",
				isSalesName: "",
				isSign: "",
			})
			// 验证表单提示
			const rules = {
				title: [{
					required: true,
					message: "请填写实事名称",
					trigger: "blur"
				}, ],
				preferentialTitle: [{
					required: true,
					message: "请填写优惠名称",
					trigger: "blur"
				}, ],
				operationMode: [{
					required: true,
					message: "请选择操作模式 ",
					trigger: "change"
				}, ],
				isPreferential: [{
					required: true,
					message: "请选择是否发放优惠 ",
					trigger: "change"
				}, ],
				cash: [{
					required: true,
					message: "请填写金额",
					trigger: "blur"
				}, ],
				isMobile: [{
					required: true,
					message: "请选择是否收集手机号  ",
					trigger: "change"
				}, ],
				isReservationTime: [{
					required: true,
					message: "请选择是否预约时间  ",
					trigger: "change"
				}, ],
				isMessage: [{
					required: true,
					message: "请选择是否收集留言   ",
					trigger: "change"
				}, ],
				isManyBuy: [{
					required: true,
					message: "请选择是否允许多次购买",
					trigger: "change"
				}, ],
				buyNumber: [{
					required: true,
					message: "请填写限制购买次数",
					trigger: "blur"
				}, ],
				isSetMenu: [{
					required: true,
					message: "请选择是否为套餐模式",
					trigger: "change"
				}, ],
				breviary1: [{
					required: true,
					message: "请上传卡片样式图片",
					trigger: "change"
				}, ],
				isSalesName: [{
					required: true,
					message: "请选择是否收集销售姓名",
					trigger: "change"
				}, ],
				isSign: [{
					required: true,
					message: "请选择是否收集销售签名",
					trigger: "change"
				}, ],
				isMessagePush: [{
					required: true,
					message: "请选择是否消息推送",
					trigger: "change"
				}, ],
				messageMobile: [{
					required: true,
					message: "请填写手机号列表",
					trigger: "blur"
				}, ],
				value1: [{
					required: true,
					message: "请选择时间",
					trigger: "change"
				}, ],
				choose: [{
					required: true,
					message: "请选择所属工会",
					trigger: "change"
				}, ],
				type: [{
					required: true,
					message: "请选择实事类型",
					trigger: "change"
				}, ],
				isEnable: [{
					required: true,
					message: "请选择是否发布",
					trigger: "change"
				}, ],
				isDisplayImage: [{
					required: true,
					message: "请选择内页是否展示主图",
					trigger: "change"
				}, ],
				breviary: [{
					required: true,
					message: "请上传主题图片",
					trigger: "change"
				}, ],
				copyreader: [{
					required: true,
					message: "请填写主题内容",
					trigger: "change"
				}, ],
			}
			return {
				qingkong,
				header,
				header1,
				data,
				// 按钮加载
				ConfirmLoading,
				// 上传图片
				// httpreqst,
				dialogVisible,
				dialogImageUrl,
				onpreview,
				onpreview1,
				beforeremove,
				beforeremove1,
				Remove,
				Remove1,
				styA,
				styA1,
				styD,
				styD1,
				change,
				change1,
				beforeImageUpload,
				beforeImageUpload1,
				// handlePictureCardPreview,
				// 编辑器
				onSubmit,
				editorRef,
				valueHtml,
				mode: 'default',
				toolbarConfig,
				editorConfig,
				handleCreated,
				// 标题验证
				ruleFormRef,
				form,
				rules,
				visible,
				texture,
				defaultProps,
				dendrogram,
				defaultTime2,
				approve,
				approve1,
				value1: [],
				handleUpImage,
				handleUpImage1,
			}
		}
	}
</script>
<style lang='scss' scoped>
	::v-deep .chart-card::-webkit-scrollbar {
		display: none
	}

	::v-deep .chart-card {
		height: calc(100vh - 145px);
		overflow: auto;
	}

	::v-deep .subject {
		margin-left: 3px;
		font-size: var(--el-form-label-font-size);
		font-weight: bold;
		margin-bottom: 5px;
		color: var(--el-text-color-regular);

		.xingxing {
			color: var(--el-color-danger);
		}
	}

	// .w-e-text-container [data-slate-editor] p{
	//   margin-top: 22px;
	//   margin-bottom: 22px;
	// }
	::v-deep .el-button {
		width: 100px;
		height: 40px;
		font-size: 16px;
	}

	::v-deep .el-form-item__content {
		align-items: flex-end;
	}

	::v-deep .referrals {
		color: #cccccc;
		margin-left: 5px;
		font-weight: 500;
	}

	::v-deep .styB .el-upload--picture-card {
		width: 110px;
		height: 110px;
		line-height: 110px;
	}

	::v-deep .styC .el-upload--picture-card {
		display: none;
	}

	::v-deep .el-form-item {
		align-items: center;
	}

	::v-deep .aaaa {
		width: 50%;
	}

	::v-deep .el-card__body {
		padding: 0;
	}

	::v-deep .el-main {
		overflow: auto !important;
	}

	::v-deep .el-card.is-always-shadow {
		width: 95%;
		margin: auto;
		margin-top: 10px;
		padding-left: 20px;
		padding-right: 20px;
		padding-bottom: 20px;
	}

	::v-deep .tabulation {
		margin-top: 10px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 10px;
		overflow: auto !important;
	}
</style>
<style scoped>
	::v-deep .upload-demo {
		display: flex;
		width: 100%;
	}

	::v-deep .upload-demo .el-upload-list {
		display: flex;
		width: 50%;
	}

	::v-deep .el-input {
		height: 44px !important;
	}

	::v-deep .el-form-item__label {
		width: 150px !important;
		font-weight: bold;
	}
</style>
